export default (): boolean => {
  const element = document.activeElement as HTMLElement | null;
  if (!element) return false;

  const { tagName, isContentEditable, className } = element;
  return (
    tagName.toLowerCase() === 'input' ||
    tagName.toLowerCase() === 'textarea' ||
    isContentEditable ||
    className.includes('PostHogSurvey') // Specific class for PostHog surveys, checks above do not cover it since ph survey is a webcomponent
  );
};
